<template lang="pug">
  #Events
    v-card(width="100%" height="400",dark )
      v-img(src="../../assets/img/background/1728708687.jpg" height="100%" style="margin-top:-85px" )
        v-row(align="center" style="height:100%")
          v-col(cols="12" align="center")
            .font-weight-black.events-title Upcoming Events
    v-container()
      v-card.my-5.mx-auto.align-self-center( v-for="(event, i) in eventsList" :key="i" height="500px"  max-width="90%" )
        .noImage()
          v-img.white--text.align-end(aspect-ratio  :src="require(`../../assets/img/events/${event.image}`)" height="500px" )
            v-card-title 
              //- .eventTitle {{event.title}}
            v-card-subtitle
              //- .eventDate {{event.date}}
            v-card-text
              //- .body-1 {{event.description}}.
              //- .title.font-weight-black Location: {{event.location}} 
</template>

<script>
import axios from 'axios';
export default {
  created() {
    axios
      .get('/data/events.json')
      .then(res => {
        console.log('created -> res', res);
        this.eventsList = res.data.data;
      })
      .catch(err => console.log(err));
  },
  data() {
    return {
      eventsList: [],
      theData: [
        {
          date: 'Feb 20, 2020',
          image: require('../../assets/img/951182240.jpeg'),
          title: 'First Event',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          location: 'ipsum dolor sit amet,'
        },
        {
          date: 'Feb 20, 2020',
          image: require('../../assets/img/951182240.jpeg'),
          title: 'Second Event',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          location: 'ipsum dolor sit amet,'
        },
        {
          date: 'Feb 20, 2020',
          image: require('../../assets/img/951182240.jpeg'),
          title: 'Third Event',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          location: 'ipsum dolor sit amet,'
        },
        {
          date: 'Feb 20, 2020',
          image: '',
          title: 'Fourth Event',
          description:
            'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
          location: 'ipsum dolor sit amet,'
        }
      ]
    };
  },
  methods: {
    getEvents() {}
  }
};
</script>

<style lang="stylus" scoped>
.events-title
  background-color var(--v-primary-darken2)
  color #fff
  font-family Cardo, 'san-serif' !important
  font-size 3rem
  font-weight 900
  line-height 96px
  width 50%
  border 10px solid var(--v-info-base)

.eventTitle
  font-size 2em
  font-weight 800
  margin-bottom 10px

.eventDate
  padding 5px
  font-size 2em
  font-weight 800
  color white
  text-align center
  background-color var(--v-secondary-lighten3)
  border 2px dashed yellow

.noImage
  background-color var(--v-secondary-base)
  height 500px
  width 100%

@media screen and (max-width: 900px)
  .events-title
    font-size 1.5rem
    line-height 48px
    width 75%

  .eventTitle
    font-size 1.5em

  .eventDate
    padding 5px
    font-size 1.5em
</style>
